module.exports = __webpack_public_path__ + "static/sec9-shoe-water-9601d0c8f62531a64f2efe87f9e1825f.png";